module.exports = __webpack_public_path__ + "img/epicerie-en-ligne-boutrais-small.af16189b.png";